module.exports = __webpack_public_path__ + "img/NonPeerReviewed.5753084.svg";